import { InjectionToken } from '@angular/core';

export const MAP_KEY = new InjectionToken<string>('mapKey');
